import { c as _c } from "react/compiler-runtime";
import { createAuthClient } from "better-auth/react";
import { useMemo } from "react";
import { useAppConfig } from "./config";

// React hook to get the auth client
export function useAuthClient() {
  const $ = _c(2);
  const config = useAppConfig();
  const t0 = config.apiUrl + "/auth";
  let t1;
  if ($[0] !== t0) {
    t1 = createAuthClient({
      baseURL: t0
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}

// React hook for auth methods
export function useAuth() {
  const $ = _c(8);
  const authClient = useAuthClient();
  let t0;
  if ($[0] !== authClient.forgetPassword || $[1] !== authClient.getSession || $[2] !== authClient.resetPassword || $[3] !== authClient.signIn || $[4] !== authClient.signOut || $[5] !== authClient.signUp || $[6] !== authClient.useSession) {
    t0 = {
      signIn: authClient.signIn,
      signUp: authClient.signUp,
      signOut: authClient.signOut,
      useSession: authClient.useSession,
      getSession: authClient.getSession,
      forgetPassword: authClient.forgetPassword,
      resetPassword: authClient.resetPassword
    };
    $[0] = authClient.forgetPassword;
    $[1] = authClient.getSession;
    $[2] = authClient.resetPassword;
    $[3] = authClient.signIn;
    $[4] = authClient.signOut;
    $[5] = authClient.signUp;
    $[6] = authClient.useSession;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  return t0;
}